<template>
  <div class="page_all_login">
    <div class="page_header_login">
      <div class="title_login">防災サポート（管理者）</div>
    </div>
    <div class="page_main">
      <table class="tbl_login">
        <tbody class="tbody_login">
          <tr>
            <td class="td_content_top">
              <div>
                <input v-model.trim="$v.userName.$model" type="text" class="text_login_id" placeholder="ID"/>
              </div>
              <div class="message">
                <div v-if="$v.userName.$dirty">
                  <div class="error" v-if="!$v.userName.required">IDを入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_middle">
              <div>
                <input v-model.trim="$v.password.$model" type="password" class="text_password" placeholder="パスワード"/>
              </div>
              <div class="message">
                <div v-if="$v.password.$dirty">
                  <div class="error" v-if="!$v.password.required">パスワードを入力してください。</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td_content_bottom">
              <div>
                <button :disabled="$v.$invalid" class="btn_login" v-on:click="loginAdmin()">ログイン</button>
                <div class="message">
                  <div class="error">{{ message }}</div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  data: function() {
    return {
      userName: "",
      password: "",
      message: ""
    }
  },
  mounted() {
    // 初期化
    // トークン情報
    this.$store.commit('setStateIdToken', "")
    this.$store.commit('setStateAccessToken', "")
    this.$store.commit('setStateRefreshToken', "")
    // ログイン情報
    this.$store.commit('setStateIsAuthenticated', false)
    this.$store.commit('setStateIsLogin', false)
    this.$store.commit('setStateIsAdmin', false)
    // 管理者情報
    this.$store.commit('setStateAdminUser', "")
  },
  methods: {
    async loginAdmin() {
      try {
        const response = await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'login/admin', {
          user_name: this.userName,
          password: this.password
        })
        // 認証済みフラグ
        this.$store.commit('setStateIsAuthenticated', true)
        // ログインフラグ
        this.$store.commit('setStateIsLogin', true)
        // 管理者フラグ
        this.$store.commit('setStateIsAdmin', true)

        // ログイン情報
        this.$store.commit('setStateAdminUser', response.data.Username)
        // トークン情報
        this.$store.commit('setStateIdToken', response.data.IdToken)
        this.$store.commit('setStateAccessToken', response.data.AccessToken)
        this.$store.commit('setStateRefreshToken', response.data.RefreshToken)
        // 認証済みフラグ = true（※管理者は当フラグは使用しないがtrueに更新）
        this.$store.commit('setStateIsAuthenticated', true)
        // 初期画面へ遷移
        this.$router.push({ name: 'municipalityList' })
      } catch (err) {
        this.password = ""
        // validationsモデルオブジェクトをリセット
        this.$v.password.$reset()
        this.message = err.response.data.errorMessage
      }
    }
  },
  validations: {
    userName: {
      required
    },
    password: {
      required
    }
  }
}
</script>

<style scoped>
table tr {
  border: none;
}
table td.td_content_top {
  text-align: left;
  border: none;
  padding: 20px 50px 0px 50px;
}
table td.td_content_middle {
  text-align: left;
  border: none;
  padding: 0px 50px 0px 50px;
}
table td.td_content_bottom {
  text-align: left;
  border: none;
  padding: 0px 50px 0px 50px;
}
</style>